import { render, staticRenderFns } from "./CommissionCarrierColumn.vue?vue&type=template&id=74e43665&scoped=true&"
import script from "./CommissionCarrierColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionCarrierColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e43665",
  null
  
)

export default component.exports